import styled from 'styled-components/macro';

export const BoardSection = styled.section`
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  overflow: auto;
  //padding: 16px 32px;
`;